import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import { RouteComponentProps } from "react-router";
import queryString from "query-string";
import { Typography, TextField, Button } from "@material-ui/core";
import CasePicker from "src/components/dialogs/casePicker";
import CaseListItem from "../cases/caseListItem";
import { User, Case, Category } from "src/api/classes";
import { DubitoSvc } from "src/api";
import Loading from "@material-ui/core/CircularProgress";
interface Props extends RouteComponentProps<{}> {
  users: User[];
  cases: Case[];
  categories: Category[];
}
interface State {}
class ClassName extends React.Component<Props, State> {
  state = {
    url: this.url,
    case: undefined,
    showCasePicker: false,
    loading: false
  };
  get url() {
    return queryString.parse(this.props.location.search).link || "";
  }
  get type() {
    return queryString.parse(this.props.location.search).type === "evidence"
      ? "evidence"
      : "claim";
  }
  componentDidMount() {
    if (this.url.length > 10) {
      this.setState({ showCasePicker: true });
    }
  }
  add = () => {
    if (this.type === "evidence") {
      this.setState({ loading: true });
      DubitoSvc.addEvidence({
        case_id: this.state.case,
        text: this.state.url
      })
        .then(() => {
          window.location.href = "/case/" + this.state.case;
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } else if (this.type === "claim") {
      this.setState({ loading: true });
      DubitoSvc.addLink({ case_id: this.state.case, url: this.state.url })
        .then(() => {
          window.location.href = "/case/" + this.state.case;
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
  };
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          alignItems: "center"
        }}
      >
        <div style={{ maxWidth: 960, width: "100%", marginTop: 64 }}>
          <Typography variant="headline">
            Add {this.type === "evidence" ? "Evidence" : "Claim"} Link to a Case
          </Typography>
          <TextField
            style={{ marginTop: 24, marginLeft: 8, marginRight: 8, flex: 1 }}
            label="URL"
            fullWidth
            value={this.state.url}
            onChange={e => this.setState({ url: e.target.value })}
          />
          <Typography
            variant="caption"
            style={{ marginTop: 24, marginBottom: 8, marginLeft: 8 }}
          >
            Case
          </Typography>
          {!this.state.case ? (
            <Button
              onClick={() => this.setState({ showCasePicker: true })}
              variant="outlined"
              style={{ marginLeft: 8 }}
            >
              Select a Case
            </Button>
          ) : (
            <CaseListItem
              case={this.props.cases.find(i => i.id === this.state.case)}
              users={this.props.users}
              categories={this.props.categories}
              onClick={() => this.setState({ showCasePicker: true })}
            />
          )}
          <CasePicker
            open={this.state.showCasePicker}
            onSelect={caseID =>
              this.setState({ case: caseID, showCasePicker: false })
            }
            onClose={() => this.setState({ showCasePicker: false })}
          />
          {this.state.loading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: 24,
                alignItems: "center"
              }}
            >
              <Loading />
              <Typography style={{ marginLeft: 8 }}>Please Wait</Typography>
            </div>
          ) : (
            <Button
              style={{ marginTop: 24 }}
              color="primary"
              variant="raised"
              disabled={!this.state.case || this.state.loading}
              onClick={this.add}
            >
              Add {this.type === "evidence" ? "Evidence" : "Claim"} Link to Case
            </Button>
          )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {
    users: state.cases.users,
    cases: state.cases.list,
    categories: state.cases.categories
  };
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassName);



// WEBPACK FOOTER //
// ./src/pages/tools/addLink.tsx